import { Agency } from '../Agencies'

export enum AssignmentMode {
  PRIMARY_AGENT_ASSIGNMENT = 'primary_agent_assignment',
  ON_CALL_ASSIGNMENT = 'on_call_assignment',
  ASSIGNMENT_BY_MANAGER = 'assignment_by_manager',
}

export interface ViewingSettings {
  assignment_mode: AssignmentMode
  duration: number
  calendar_increment: number
  standby_threshold: number
  max_leads: number
  max_forward: number
  anticipation_delay: number
  agency_id: Agency['id']
  id: string
  instructions?: string
  instructions_is_active?: boolean
  hide_full_address?: boolean
  set_asset_available_on_activation?: boolean
}
